"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1849],{

/***/ 77061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23094);
/* harmony import */ var _utils_get_customer_age_bracket__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29874);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2798);
/* harmony import */ var _selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34112);





// @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(dispatch, getState) {
        var globalState = getState();
        var customer = (0,_selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(data) || (0,_selectors_select_customer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(globalState) || {};
        var ageBracket = (0,_utils_get_customer_age_bracket__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(customer);
        var productIdsArray = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(productIds) ? productIds : [
            productIds
        ];
        var conditions = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pick)([
            "dependants",
            "incomeTier",
            "members",
            "rebate",
            "state",
            "scale",
            "starts",
            "payment"
        ], data);
        var conditionsWithDefaults = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.defaultsAll)([
            conditions,
            {
                ageBracket: ageBracket
            },
            customer
        ]);
        var keys = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(productId) {
            return _models_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getKey */ .Z.getKey(productId, conditionsWithDefaults, options);
        }, productIdsArray);
        return dispatch({
            keys: keys,
            // @ts-expect-error - Automatic, Please fix when editing this file
            promise: function(api) {
                return _models_price__WEBPACK_IMPORTED_MODULE_2__/* ["default"].loadPrices */ .Z.loadPrices(api, productIdsArray, conditionsWithDefaults, options);
            },
            types: [
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD */ .f8,
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD_SUCCESS */ .ZI,
                _action_types__WEBPACK_IMPORTED_MODULE_4__/* .PRICE_LOAD_FAIL */ .Ct
            ]
        });
    };
}
function changeEffectiveDate() {
    var useFutureEffectiveDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        type: _action_types__WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_EFFECTIVE_DATE */ .Bj,
        useFutureEffectiveDate: useFutureEffectiveDate
    };
}
var PriceActions = {
    changeEffectiveDate: changeEffectiveDate,
    load: load
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceActions);


/***/ }),

/***/ 76383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ price_disclaimer; }
});

// UNUSED EXPORTS: PriceBreakdownForTest, getAgeSentence, getIncomeSentence, getLHCSentence, getProductSentence, getRebateSentence, getYouthDiscountSentence, mapStateToProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/price-disclaimer/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.75rem;\n  margin: 0.5rem auto;\n  max-width: ",
        ";\n  text-size-adjust: 100%;\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      margin: 1rem 0 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  line-height: 1.5rem;\n  margin: 1rem auto 0;\n  padding: calc(1rem - 2px);\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      ",
        "\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var textAlignStyles = (0,styled_components_browser_esm.css)(_templateObject(), function(param) {
    var center = param.center;
    return center ? "center" : "left";
});
var StyledP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-486ac8bf-0"
})(_templateObject1(), function(param) {
    var $constrainWidth = param.$constrainWidth, theme = param.theme;
    return $constrainWidth ? theme.media.sm : "100%";
}, textAlignStyles);
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-486ac8bf-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm.css)(_templateObject2(), theme.mediaQueries.below(theme.media.md));
});
var StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-486ac8bf-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, textAlignStyles);
var DisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-486ac8bf-3"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm.css)(_templateObject5(), theme.mediaQueries.above(theme.media.md), function(param) {
        var hideForDesktop = param.hideForDesktop;
        return hideForDesktop ? "display: none;" : "";
    });
});

// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
// EXTERNAL MODULE: ./src/client/utils/has-hospital-component/index.ts
var has_hospital_component = __webpack_require__(97279);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
// EXTERNAL MODULE: ./src/client/selectors/select-calculated-youth-discount-percentage/index.ts
var select_calculated_youth_discount_percentage = __webpack_require__(4528);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
// EXTERNAL MODULE: ./src/client/selectors/select-cart/index.ts
var select_cart = __webpack_require__(1767);
// EXTERNAL MODULE: ./src/client/selectors/select-products/index.ts
var select_products = __webpack_require__(2664);
;// CONCATENATED MODULE: ./src/client/selectors/select-cart-hospital-or-package-product/index.ts



var selectCartHospitalOrPackageProduct = (0,reselect_es.createSelector)([
    select_cart/* default */.Z,
    select_products/* default */.Z
], function(cart, products) {
    var ref, ref1;
    var hospitalId = cart === null || cart === void 0 ? void 0 : (ref = cart.hospital) === null || ref === void 0 ? void 0 : ref.id;
    var packageId = cart === null || cart === void 0 ? void 0 : (ref1 = cart.package) === null || ref1 === void 0 ? void 0 : ref1.id;
    var ref2;
    return (ref2 = products === null || products === void 0 ? void 0 : products[packageId || hospitalId]) !== null && ref2 !== void 0 ? ref2 : null;
});
/* harmony default export */ var select_cart_hospital_or_package_product = (selectCartHospitalOrPackageProduct);

// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-customer-human-readable/index.ts
var select_customer_human_readable = __webpack_require__(34089);
// EXTERNAL MODULE: ./src/client/selectors/select-is-excess-toggle-applicable/index.ts
var select_is_excess_toggle_applicable = __webpack_require__(78260);
// EXTERNAL MODULE: ./src/client/selectors/select-prices/index.ts
var select_prices = __webpack_require__(1318);
// EXTERNAL MODULE: ./src/client/selectors/select-rebate-percentage/index.ts
var select_rebate_percentage = __webpack_require__(10073);
;// CONCATENATED MODULE: ./src/client/components/price-disclaimer/index.tsx




















var getAgeSentence = // @ts-expect-error - Automatic, Please fix when editing this file
function(DataWrapper) {
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(ages) {
        var usePossessiveDeterminer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "based on",
                (0,fp.has)(ahm_constants/* default.RELATIONSHIP.CLIENT */.Z.RELATIONSHIP.CLIENT, ages) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
                    children: [
                        " ",
                        usePossessiveDeterminer ? "your" : "an",
                        " age of ",
                        ages[ahm_constants/* default.RELATIONSHIP.CLIENT */.Z.RELATIONSHIP.CLIENT]
                    ]
                }),
                (0,fp.has)(ahm_constants/* default.RELATIONSHIP.CLIENT */.Z.RELATIONSHIP.CLIENT, ages) && (0,fp.has)(ahm_constants/* default.RELATIONSHIP.SPOUSE */.Z.RELATIONSHIP.SPOUSE, ages) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: " and"
                }),
                (0,fp.has)(ahm_constants/* default.RELATIONSHIP.SPOUSE */.Z.RELATIONSHIP.SPOUSE, ages) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
                    children: [
                        " ",
                        usePossessiveDeterminer ? "your" : "a",
                        " partner’s age of ",
                        ages[ahm_constants/* default.RELATIONSHIP.SPOUSE */.Z.RELATIONSHIP.SPOUSE]
                    ]
                })
            ]
        });
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getYouthDiscountSentence = function(DataWrapper) {
    return function(customer) {
        var ages = customer.ages, calculatedYouthDiscountPercentage = customer.calculatedYouthDiscountPercentage, whicsYouthDiscountPercentage = customer.whicsYouthDiscountPercentage;
        var youthDiscountPercentage = whicsYouthDiscountPercentage || calculatedYouthDiscountPercentage;
        if (youthDiscountPercentage > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    ", a Youth Discount of ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
                        children: [
                            youthDiscountPercentage,
                            "%"
                        ]
                    }),
                    " (",
                    getAgeSentence(DataWrapper)(ages, true),
                    ")",
                    " "
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                ", ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: "excludes"
                }),
                " any Youth Discount",
                " "
            ]
        });
    };
};
var getIncomeSentence = // @ts-expect-error - Automatic, Please fix when editing this file
function(DataWrapper) {
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    // eslint-disable-next-line react/prop-types
    function(param) {
        var incomeTier = param.incomeTier, incomeType = param.incomeType;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: incomeType
                }),
                " income of ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: incomeTier
                }),
                " per year"
            ]
        });
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getRebateSentence = function(DataWrapper) {
    return function(customer) {
        var ageBracket = customer.ageBracket, rebatePercentage = customer.rebatePercentage, rebate = customer.rebate;
        return rebate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Price reduced by an Australian Government Rebate of ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
                    children: [
                        rebatePercentage,
                        "%"
                    ]
                }),
                " (",
                getAgeSentence(DataWrapper)((0,_define_property/* default */.Z)({}, ahm_constants/* default.RELATIONSHIP.CLIENT */.Z.RELATIONSHIP.CLIENT, ageBracket), false),
                ",",
                " ",
                getIncomeSentence(customer.highlightIncome ? DataWrapper : react.Fragment)(customer),
                ").",
                " "
            ]
        }) : "Australian Government Rebate is not applied. ";
    };
};
var getPriceSentence = // @ts-expect-error - Automatic, Please fix when editing this file
function(DataWrapper) {
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    // eslint-disable-next-line react/prop-types
    function(param) {
        var scale = param.scale, state = param.state, frequency = param.frequency;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Price is for ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: scale
                }),
                " cover in ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: state
                }),
                " paying",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: frequency
                }),
                " by direct debit.",
                " "
            ]
        });
    });
};
var getLHCSentence = // @ts-expect-error - Automatic, Please fix when editing this file
function(DataWrapper) {
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    // eslint-disable-next-line react/prop-types
    function(param) {
        var lhc = param.lhc;
        return lhc > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                " ",
                "and ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: "includes"
                }),
                " Lifetime Health Cover loading of ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
                    children: [
                        lhc,
                        "%"
                    ]
                }),
                "."
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                " ",
                "and ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrapper, {
                    children: "excludes"
                }),
                " Lifetime Health Cover loading.",
                " "
            ]
        });
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getExcessPart = function(DataWrapper) {
    return function(customer, product) {
        var excessAmount = (0,fp.get)("charges.excess.amount", product);
        if ((0,fp.isNil)(excessAmount)) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataWrapper, {
            children: [
                "an excess of $",
                excessAmount
            ]
        });
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getProductSentence = function(DataWrapper) {
    return function(customer, product) {
        if (!product || (0,fp.get)("type", product) === ahm_constants/* default.PRODUCT_TYPE.EXTRAS */.Z.PRODUCT_TYPE.EXTRAS) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                " ",
                (0,fp.upperFirst)(ahm_constants/* default.PRODUCT_TYPE.HOSPITAL */.Z.PRODUCT_TYPE.HOSPITAL),
                " price includes",
                " ",
                getExcessPart(customer.highlightExcess ? DataWrapper : react.Fragment)(customer, product),
                getYouthDiscountSentence(DataWrapper)(customer),
                getLHCSentence(DataWrapper)(customer)
            ]
        });
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getYouthDiscountPercentageFromPrices = function(prices, productId, customer) {
    var price = models_price/* default.getPrice */.Z.getPrice(prices, productId, customer);
    return (0,fp.get)("youthDiscount", price);
};
var PriceDisclaimer = function(param) {
    var bold = param.bold, calculatedYouthDiscountPercentage = param.calculatedYouthDiscountPercentage, cartHospitalOrPackageProduct = param.cartHospitalOrPackageProduct, center = param.center, className = param.className, constrainWidth = param.constrainWidth, customer = param.customer, customerReadable = param.customerReadable, elementType = param.elementType, forProducts = param.forProducts, hideForDesktop = param.hideForDesktop, highlightExcess = param.highlightExcess, highlightIncome = param.highlightIncome, indicator = param.indicator, openChangeDetailsDrawer = param.openChangeDetailsDrawer, prices = param.prices, rebatePercentage = param.rebatePercentage, showRefineLink = param.showRefineLink, showRefineLinkInline = param.showRefineLinkInline;
    var DataWrapper = bold ? ahm_ui/* Strong */.cK : react.Fragment;
    var radix = 10;
    // We check if the product excess matches customer excess, because we display greyed out products of other excess types on the comparer.
    var hospitalProductWithExcess = (0,fp.find)(function(product) {
        var customerExcess = (0,fp.parseInt)(radix, (0,fp.get)("hospitalExcess")(customer));
        var hasExcessMatchingCustomer = customerExcess === (0,fp.get)("charges.excess.amount")(product);
        return (0,has_hospital_component/* default */.Z)(product) && hasExcessMatchingCustomer;
    })(forProducts);
    var product = hospitalProductWithExcess || (0,fp.head)(forProducts) || cartHospitalOrPackageProduct;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var whicsYouthDiscountPercentage = product && getYouthDiscountPercentageFromPrices(prices, product.id, customer);
    var customerData = (0,fp.defaultsAll)([
        {
            calculatedYouthDiscountPercentage: calculatedYouthDiscountPercentage,
            highlightExcess: highlightExcess,
            highlightIncome: highlightIncome,
            rebatePercentage: rebatePercentage,
            whicsYouthDiscountPercentage: whicsYouthDiscountPercentage
        },
        customerReadable,
        customer, 
    ]);
    var refinePriceElement = null;
    if (showRefineLink) {
        refinePriceElement = elementType === "button" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                center: center,
                onClick: openChangeDetailsDrawer,
                variant: [
                    "border",
                    "wide",
                    "white"
                ],
                children: "Refine price"
            })
        }) : // @ts-expect-error - Automatic, Please fix when editing this file
        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiv, {
            center: center,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                onClick: openChangeDetailsDrawer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                    variant: "small14",
                    children: "Refine these details"
                })
            })
        });
    }
    var Paragraph = StyledP;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisclaimerWrapper, {
        hideForDesktop: hideForDesktop,
        "data-nosnippet": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                $constrainWidth: constrainWidth,
                className: className,
                children: [
                    indicator,
                    getPriceSentence(DataWrapper)(customerData),
                    getRebateSentence(DataWrapper)(customerData),
                    getProductSentence(DataWrapper)(customerData, product),
                    showRefineLinkInline && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                        onClick: openChangeDetailsDrawer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                            children: "Refine price"
                        })
                    })
                ]
            }),
            refinePriceElement
        ]
    }));
};
PriceDisclaimer.defaultProps = {
    bold: false,
    cartHospitalOrPackageProduct: null,
    center: false,
    className: null,
    constrainWidth: false,
    elementType: "clickable",
    forProducts: [],
    hideForDesktop: false,
    highlightExcess: false,
    highlightIncome: false,
    indicator: "*",
    prices: null,
    showRefineLink: false,
    showRefineLinkInline: false
};
var mapStateToProps = function(state) {
    return {
        calculatedYouthDiscountPercentage: (0,select_calculated_youth_discount_percentage/* default */.Z)(state),
        cartHospitalOrPackageProduct: select_cart_hospital_or_package_product(state),
        customer: (0,select_customer/* default */.Z)(state),
        customerReadable: (0,select_customer_human_readable/* default */.Z)(state),
        // @ts-expect-error - Automatic, Please fix when editing this file
        highlightExcess: (0,select_is_excess_toggle_applicable/* default */.ZP)(state),
        prices: (0,select_prices/* default */.Z)(state),
        rebatePercentage: (0,select_rebate_percentage/* default */.Z)(state)
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    var drawerActions = (0,redux/* bindActionCreators */.DE)(drawer/* default */.Z, dispatch);
    return {
        openChangeDetailsDrawer: function() {
            return drawerActions.openDrawer(ui.DRAWER_IDS.CHANGE_DETAILS);
        }
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var price_disclaimer = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PriceDisclaimer));



/***/ }),

/***/ 26789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ahmdigital_urls_lib_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55105);
/* harmony import */ var _ahmdigital_urls_lib_builder__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_urls_lib_builder__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var UrlService = {
    // @ts-expect-error - Automatic, Please fix when editing this file
    getProductUrl: function(productId) {
        return _ahmdigital_urls_lib_builder__WEBPACK_IMPORTED_MODULE_0___default().getProductUrl({
            errorUrl: _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].URLS.SALES.ERROR_404 */ .Z.URLS.SALES.ERROR_404,
            productId: productId,
            rawUrl: _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].URLS.SALES.PRODUCT */ .Z.URLS.SALES.PRODUCT
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (UrlService);


/***/ }),

/***/ 34089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10453);
/* harmony import */ var _utils_get_income_tier_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2001);
/* harmony import */ var _select_age_bracket_option__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66734);
/* harmony import */ var _select_customer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34112);
/* harmony import */ var _select_youth_discount_ages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1101);







// @ts-expect-error - Automatic, Please fix when editing this file
var getIncomeTier = function(customer) {
    var ref;
    return (ref = (0,_utils_get_income_tier_options__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        incomeType: customer.incomeType
    })) === null || ref === void 0 ? void 0 : ref[customer.incomeTier];
};
var selectCustomerHumanReadable = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    _select_age_bracket_option__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    _select_customer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    _select_youth_discount_ages__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
], function(ageBracket, customer, ages) {
    return {
        ageBracket: ageBracket,
        ages: ages,
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
        incomeTier: getIncomeTier(customer).text,
        incomeType: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.toLower)(_ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].INCOME_TYPE_LABEL */ .Z.INCOME_TYPE_LABEL[customer.incomeType]),
        scale: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.lowerCase)(_ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SCALE_LABEL */ .Z.SCALE_LABEL[customer.scale]),
        state: _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].STATE_LABEL */ .Z.STATE_LABEL[customer.state]
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (selectCustomerHumanReadable);


/***/ }),

/***/ 58400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getExcessToggleValues */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_utils_get_parent_product_id__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36529);
/* harmony import */ var _ahmdigital_logic_lib_utils_get_parent_product_id__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_get_parent_product_id__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93590);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10453);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93216);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99846);
/* harmony import */ var _select_cart__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1767);
/* harmony import */ var _select_products__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2664);









/**
 * Select saleable hospital excess for cart hospital/package product.
 *
 * @param {object} cart - Cart from state.
 * @param {object} products - Products from state.
 * @returns {number[]} Returns an array of saleable hospital excess.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getExcessToggleValues = function(cart, products) {
    if (cart.baseProductType === _ahm_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].PRODUCT_TYPE.EXTRAS */ .Z.PRODUCT_TYPE.EXTRAS) {
        return [];
    }
    // if you're on a product page your cart is auto-populated with the current product's ids
    var productId = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("hospital.id")(cart) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("package.id")(cart);
    if (!productId) {
        // select all excess options by default as we have no restrictions and exit early e.g. for product comparer
        // can't use compact because it rejects '0' as falsey
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.filter)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isNumber, _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_3__.EXCESS_TYPES);
    }
    // Because of Choosable #ART-881, we can have a product in the cart but not in the product state - in this instance we
    // won't know valid excess for the product until they navigate back to a hospital/package details/buy page
    if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)(productId)(products)) {
        return [];
    }
    // Find all saleable products with the same parent product id, and then get all excess amounts for the product group
    var parentProductId = _ahmdigital_logic_lib_utils_get_parent_product_id__WEBPACK_IMPORTED_MODULE_2___default()(productId);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var saleableProductIds = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.intersection)((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)(parentProductId)(_ahm_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].PRODUCTS_BY_PARENT */ .Z.PRODUCTS_BY_PARENT));
    var saleableProducts = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)(saleableProductIds)(products);
    // e.g 750 product in our cart, PRODUCTS_BY_PARENT shows 500 & 750, but 500 isn't in product state
    // This should never be the case, but if this happens we should investigate why a product failed to load alt. excess
    // this can be cleaned up if we don't see this behaviour
    if (saleableProductIds.length !== (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.size)(saleableProducts)) {
        _logging__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getLogger */ .Z.getLogger().error("Unable to load all excess. Missing expected product in state", {
            cartProduct: productId,
            expectedSaleableProductIds: saleableProductIds,
            missingProducts: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.difference)(saleableProductIds, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.keys)(saleableProducts))
        });
    }
    // if the products haven't loaded into state they'll have undefined amounts, so we should not show them yet
    var hospitalExcess = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.map)("charges.excess.amount"), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.filter)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isNumber))(saleableProducts).sort();
    return hospitalExcess;
};
var selectExcessToggleValues = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    _select_cart__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
    _select_products__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
], getExcessToggleValues);
/* harmony default export */ __webpack_exports__["Z"] = (selectExcessToggleValues);



/***/ }),

/***/ 78260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports restrictedLandingPages, isExcessToggleApplicable */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10453);
/* harmony import */ var _utils_get_is_extras_comparer_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62833);
/* harmony import */ var _select_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1767);
/* harmony import */ var _select_excess_toggle_values__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58400);
/* harmony import */ var _select_location__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88176);
/* harmony import */ var _select_needs_product_type__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82488);
/* harmony import */ var _select_needs_type__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69286);









var URLS = _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].URLS */ .Z.URLS;
var MINIMUM_EXCESS_VALUES_FOR_TOGGLE = 2;
var restrictedLandingPages = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)([
    "CHOOSE_YOUR_COVER",
    "MEDIA_LANDING",
    "NO_GAP_DENTAL",
    "OFFER_FRIEND",
    "PREGNANCY",
    "TAX"
], URLS.SALES);
// @ts-expect-error - Automatic, Please fix when editing this file
var isExcessToggleApplicable = function(cart, location, excessToggleValues, needsProductType, needsType) {
    var isOnRestrictedLandingPage = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.includes)(location, restrictedLandingPages);
    var hasOnlyExtrasInCart = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("baseProductType")(cart) === _ahm_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PRODUCT_TYPE.EXTRAS */ .Z.PRODUCT_TYPE.EXTRAS && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("hospital.id")(cart));
    var isOnSingleExcessProduct = excessToggleValues.length < MINIMUM_EXCESS_VALUES_FOR_TOGGLE;
    return !(hasOnlyExtrasInCart || isOnSingleExcessProduct || isOnRestrictedLandingPage || (0,_utils_get_is_extras_comparer_page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        needsProductType: needsProductType,
        needsType: needsType
    }));
};
var selectIsExcessToggleApplicable = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    _select_cart__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    _select_location__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    _select_excess_toggle_values__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    _select_needs_product_type__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    _select_needs_type__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
], isExcessToggleApplicable);
/* harmony default export */ __webpack_exports__["ZP"] = (selectIsExcessToggleApplicable);



/***/ }),

/***/ 82488:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

// @ts-expect-error - Automatic, Please fix when editing this file
var ref;
var selectNeedsProductType = function(state, props) {
    var ref1, ref2;
    return (ref = props === null || props === void 0 ? void 0 : (ref1 = props.match) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.params) === null || ref2 === void 0 ? void 0 : ref2.needsProductType) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectNeedsProductType);


/***/ }),

/***/ 69286:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

// @ts-expect-error - Automatic, Please fix when editing this file
var ref;
var selectNeedsType = function(state, props) {
    var ref1, ref2;
    return (ref = props === null || props === void 0 ? void 0 : (ref1 = props.match) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.params) === null || ref2 === void 0 ? void 0 : ref2.needsType) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectNeedsType);


/***/ }),

/***/ 62833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var CUSTOMER_NEEDS = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CUSTOMER_NEEDS */ .Z.CUSTOMER_NEEDS, PRODUCTS_BY_NEEDS = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCTS_BY_NEEDS */ .Z.PRODUCTS_BY_NEEDS, PRODUCT_TYPE = _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_TYPE */ .Z.PRODUCT_TYPE;
// @ts-expect-error - Automatic, Please fix when editing this file
var getIsExtrasComparerPage = function(param) {
    var needsProductType = param.needsProductType, needsType = param.needsType;
    if (!(needsProductType && needsType)) {
        return false;
    }
    var applicableNeedsProductType = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.keys)(PRODUCTS_BY_NEEDS[CUSTOMER_NEEDS.EXTRAS_COVER]);
    var hasApplicableNeedsProductType = needsType === CUSTOMER_NEEDS.EXTRAS_COVER && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(needsProductType, applicableNeedsProductType);
    var hasApplicableNeedsType = needsProductType === PRODUCT_TYPE.EXTRAS && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(needsType, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.values)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.pick)([
        "BARE_BONES",
        "FAMILY"
    ], CUSTOMER_NEEDS)));
    return hasApplicableNeedsType || hasApplicableNeedsProductType;
};
/* harmony default export */ __webpack_exports__["Z"] = (getIsExtrasComparerPage);


/***/ })

}]);